import { render, staticRenderFns } from "./DeviceAdd.vue?vue&type=template&id=5724663c"
import script from "./DeviceAdd.vue?vue&type=script&lang=js"
export * from "./DeviceAdd.vue?vue&type=script&lang=js"
import style0 from "./DeviceAdd.vue?vue&type=style&index=0&id=5724663c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports